import {
  ClockCountdown,
  ExpiredText,
  FlashSaleTimerHeaderProps,
  Styled,
} from '.';

const FlashSaleTimerHeader = ({ expiresAt }: FlashSaleTimerHeaderProps) => {
  const isOfferExpired = new Date(expiresAt) < new Date();

  return (
    <Styled.FlashSalesContainer>
      {isOfferExpired ? (
        <ExpiredText />
      ) : (
        <ClockCountdown expiresAt={expiresAt} />
      )}
    </Styled.FlashSalesContainer>
  );
};

export default FlashSaleTimerHeader;
